export const ConfigPrimaryBadgeType = {
  PENDING_RESERVATION: 'PENDING_RESERVATION',
  CANCEL_PENALTY: 'CANCEL_PENALTY',
  MILLION_COUPON: 'MILLION_COUPON',
  SP_MILLION_COUPON: 'SP_MILLION_COUPON',
  Y_FLUX: 'Y_FLUX',
  MILLION_COUPON_MOTEL: 'MILLION_COUPON_MOTEL',
  LEISURE_COUPON: 'LEISURE_COUPON',
  DAY_USE: 'DAY_USE',
  /** 킹특가, 최저가보상 */
  ONE_OFF_PROMOTION: 'ONE_OFF_PROMOTION',
  PAYBACK: 'PAYBACK',
  /** 레저 > 레포츠대전 */
  PLAY_BATTLE: 'PLAY_BATTLE',
} as const

export type TConfigPrimaryBadgeType = keyof typeof ConfigPrimaryBadgeType

export const BADGE_NAME_MAP = {
  [ConfigPrimaryBadgeType.PENDING_RESERVATION]: '예약확정대기',
  [ConfigPrimaryBadgeType.CANCEL_PENALTY]: 'NOL케어',
  [ConfigPrimaryBadgeType.MILLION_COUPON]: '숙박페스타',
  [ConfigPrimaryBadgeType.SP_MILLION_COUPON]: '숙박페스타 특별편',
  [ConfigPrimaryBadgeType.LEISURE_COUPON]: '놀이대전',
  [ConfigPrimaryBadgeType.MILLION_COUPON_MOTEL]: '모텔대전',
  [ConfigPrimaryBadgeType.Y_FLUX]: 'QR체크인',
  [ConfigPrimaryBadgeType.ONE_OFF_PROMOTION]: '이번주특가',
  [ConfigPrimaryBadgeType.PAYBACK]: '1%적립',
  [ConfigPrimaryBadgeType.PLAY_BATTLE]: '레포츠대전',
} as const

/**
 * 통합주문 내 배지 노출 정책
 * https://yanolja.atlassian.net/wiki/spaces/platformdiv/pages/90261635
 */
export const DomesticBadgeHidePolicies = {
  // 장바구니 - 숙박 미노출 배지
  onCartProperty: [
    ConfigPrimaryBadgeType.MILLION_COUPON,
    ConfigPrimaryBadgeType.SP_MILLION_COUPON,
    ConfigPrimaryBadgeType.DAY_USE,
  ],
  // 장바구니 - 객실 미노출 배지
  onCartOption: [
    ConfigPrimaryBadgeType.MILLION_COUPON,
    ConfigPrimaryBadgeType.SP_MILLION_COUPON,
    ConfigPrimaryBadgeType.MILLION_COUPON_MOTEL,
    ConfigPrimaryBadgeType.CANCEL_PENALTY,
    ConfigPrimaryBadgeType.Y_FLUX,
    ConfigPrimaryBadgeType.DAY_USE,
  ],
  // 예약, 예약 완료 - 숙박 단위는 아래의 배지 미노출
  onOrderProperty: [
    ConfigPrimaryBadgeType.MILLION_COUPON,
    ConfigPrimaryBadgeType.SP_MILLION_COUPON,
    ConfigPrimaryBadgeType.DAY_USE,
  ],
  // 대실 상품의 경우 숙박대전 배지 미노출
  onDayUse: [
    ConfigPrimaryBadgeType.MILLION_COUPON,
    ConfigPrimaryBadgeType.SP_MILLION_COUPON,
    ConfigPrimaryBadgeType.DAY_USE,
  ],
}
